import React from 'react';
import {TabbedOverviewPage, ReadinessSolutionOverviewSection} from '../components/OverviewSections.comp';

const AboutReadinessSolutionPage = () => (
    <TabbedOverviewPage
        skipNoDataGate
        tabs={[
            {
                label: 'Child Online Safety (COS) Readiness Solution',
                content: <ReadinessSolutionOverviewSection/>,
            },
        ]}
    />
);

export default AboutReadinessSolutionPage;
